import React, { useCallback, useEffect, useState } from 'react';
import { get } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import { Icon } from '@doxyme/ui';
import { getToasts } from '../../selectors/toasts';
import { removeToast } from '../../actions/toasts';
import { RawHTML } from '../raw-html';
const FADE_ANIMATION_TIME = 300; // ms
// now this component just uses styles (by using same class names) from angular notifications
// todo: rewrite it with custom styles or another library after migration
export const GlobalNotifications = () => {
    const dispatch = useDispatch();
    const toasts = useSelector(getToasts);
    const close = useCallback((toast) => dispatch(removeToast(toast.id)), []);
    const onNotificationClick = useCallback(
    // do we need this 'if', maybe just to close on any click?
    (e, toast) => get(e, 'nativeEvent.target.dataset.notificationClose') && close(toast), []);
    // hack to have same behavior as in angular - fade out last notification
    // when not needed - remove below block of code and use 'toasts' in render
    const [toastsToDisplay, setToastsToDisplay] = useState([]);
    useEffect(() => {
        const timer = setTimeout(() => setToastsToDisplay(toasts), toasts.length === 0 ? FADE_ANIMATION_TIME : 0);
        return () => clearTimeout(timer);
    }, [toasts]);
    const containerClassName = classnames('notifications-container', !toasts.length && 'js-st-instance');
    return (<div className="notifications">
      {!!toastsToDisplay.length && (<div className={containerClassName}>
          {toastsToDisplay.map(toast => (<div key={toast.id} className={toast.type} onClick={(e) => onNotificationClick(e, toast)}>
              <RawHTML className="message">{toast.message}</RawHTML>
              <span onClick={(e) => close(toast)}>
                <Icon className="icon " name="close" size="x-small"/>
              </span>
            </div>))}
        </div>)}
    </div>);
};
export default GlobalNotifications;
